/**
 * Small fetch helpers that automatically attach the stored JWT access token.
 *
 * Backend uses Flask-JWT-Extended and expects:
 *   Authorization: Bearer <access_token>
 *
 * Note: this project currently stores the token via JSON.stringify(), so we
 * support both raw-string and JSON-stringified storage formats.
 */
export function getStoredAccessToken() {
  const raw = localStorage.getItem("token");
  if (!raw) return null;

  // Common case in this repo: JSON.stringify(token) -> "\"eyJ...\""
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === "string" ? parsed : raw;
  } catch {
    return raw;
  }
}

export function apiFetch(input, init = {}) {
  const token = getStoredAccessToken();
  const headers = new Headers(init.headers || {});
  const credentials = init.credentials ?? "same-origin";

  // Only add if we have a token and caller didn't explicitly set it.
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(input, { ...init, headers, credentials });
}

async function parseResponseBody(res) {
  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return await res.json();
  }
  return await res.text();
}

export async function apiFetchJson(input, init = {}) {
  const res = await apiFetch(input, init);
  const body = await parseResponseBody(res);

  if (!res.ok) {
    const err = new Error(`Request failed: ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return body;
}

